import { render, staticRenderFns } from "./PermissionMapDialog.vue?vue&type=template&id=6cf87fc4&"
import script from "./PermissionMapDialog.vue?vue&type=script&lang=ts&"
export * from "./PermissionMapDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports